/**
 * @description fullPath에서 parentPath를 기준으로 상대 경로를 반환하는 함수입니다.
 * @param fullPath 전체 경로 (예: ‘/page/connect_account/result’)
 * @param parentPath 부모 경로 (예: ‘/page/*’ 또는 ‘/page’)
 * @returns 상대 경로 (예: ‘connect_account/result’)
 */
export const getRelativeRoute = (
  fullPath: string,
  parentPath: string,
): string => {
  // parentPath가 '/*'로 끝날 경우, '/*'를 제거
  const normalizedParent = parentPath.endsWith('/*')
    ? parentPath.slice(0, -2)
    : parentPath;

  // fullPath가 parentPath로 시작하지 않는 경우 그대로 반환
  if (!fullPath.startsWith(normalizedParent)) {
    return fullPath;
  }

  // parentPath 이후 경로 추출
  const sliced = fullPath.slice(normalizedParent.length);
  const relativePath = sliced.startsWith('/') ? sliced.slice(1) : sliced;

  return relativePath;
};
